import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { PageHeader, HomeHeader, BannerCenter, BannerButton } from "../utils"
import lakeShore from "../images/bcg/clemson-restaurant-on-lake-hartwell.jpg"
import food from "../images/bcg/crab-cakes-red-wine.jpg"
import QuickInfo from "../components/HomePageComponents/QuickInfo"

const MenuPage = ({ location }) => (
  <Layout>
    <SEO
      title="Menu"
      img={food}
      url={location.href}
    />

    <div id="menu-links">
      <PageHeader img={lakeShore}>
        <BannerCenter title="The Menu" subtitle="Lakeside Dining & Takeout">
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/2gMUG1LElDTVEm6oBXWo6G/b4e69141b5626625bace8c3adbe4beac/TRADITIONS-Game-Day-2026.pdf.pdf">Game Day</a>
          </BannerButton>
          <br/>
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/5AJ3R2ao5vfJn5zR5FgpIw/f133dc1e84a1b0f6a1613747395d5543/PDF-TRADITIONS-DINNER-SPRING-2026.pdf">Dinner</a>
          </BannerButton>
          <br/>
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/4KrAFiahD2BbgDwvrU8yiR/60cf3ba3c5196ac3b2264db3f56a165c/TRADITIONS-Lunch-Revised-4-2025.pdf">Lunch</a>
          </BannerButton>
          <br/>
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/3c8ha2hzLfxioelNgWCcHJ/ea5624f940b751118a8d8c8ca7a41850/TRADITIONS-Brunch-V5-9-26.pdf">Saturday & Sunday Brunch</a>
          </BannerButton>
          <br/>
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/pHnGYpQ3f5mb3YbbSbxNm/1354a081441fb87928fdb311f7df0ae8/TRADITIONS-KIDS-Dinner-4-2025.pdf">Kids Menu</a>
          </BannerButton>
          <br/>
          <BannerButton>
            <a href="https://assets.ctfassets.net/j4osy1ytcga2/5kMPQJCoswq4Qq2AHPLIBq/86e948e14c30d8f3e66b4d97be890921/TOTL-Beer-Wine-Summer-2025-REV.pdf">Beer & Wine</a>
          </BannerButton>
        </BannerCenter>
      </PageHeader>
      <QuickInfo></QuickInfo>
      <HomeHeader img={food}></HomeHeader>
    </div>
  </Layout>
)

export default MenuPage
